import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt, faLink, faFacebook, faTwitter, faLinkedin, faWhatsapp } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter as faTwitterBrand, faLinkedinIn, faWhatsapp as faWhatsappBrand } from '@fortawesome/free-brands-svg-icons';

const BlogPostShare = ({ post }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareTitle = post.title;
  const shareText = post.title;

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${shareTitle} ${shareUrl}`)}`
  };

  const handleShare = (platform) => {
    const url = shareLinks[platform];
    if (url) {
      window.open(url, '_blank', 'width=600,height=400');
    }
    setShowShareMenu(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      // Aquí podrías mostrar una notificación de éxito
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy link:', err);
      alert('Failed to copy link');
    }
    setShowShareMenu(false);
  };

  return (
    <div className="blog-post-share">
      <button
        className="blog-post-share__button"
        onClick={() => setShowShareMenu(!showShareMenu)}
        aria-label="Share this post"
      >
        <FontAwesomeIcon icon={faShareAlt} />
        Share
      </button>
      
      {showShareMenu && (
        <div className="blog-post-share__menu">
          <div className="blog-post-share__menu-header">
            <h4>Share this post</h4>
            <button
              className="blog-post-share__close"
              onClick={() => setShowShareMenu(false)}
              aria-label="Close share menu"
            >
              ×
            </button>
          </div>
          
          <div className="blog-post-share__options">
            <button
              className="blog-post-share__option blog-post-share__option--facebook"
              onClick={() => handleShare('facebook')}
            >
              <FontAwesomeIcon icon={faFacebookF} />
              Facebook
            </button>
            
            <button
              className="blog-post-share__option blog-post-share__option--twitter"
              onClick={() => handleShare('twitter')}
            >
              <FontAwesomeIcon icon={faTwitterBrand} />
              Twitter
            </button>
            
            <button
              className="blog-post-share__option blog-post-share__option--linkedin"
              onClick={() => handleShare('linkedin')}
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
              LinkedIn
            </button>
            
            <button
              className="blog-post-share__option blog-post-share__option--whatsapp"
              onClick={() => handleShare('whatsapp')}
            >
              <FontAwesomeIcon icon={faWhatsappBrand} />
              WhatsApp
            </button>
            
            <button
              className="blog-post-share__option blog-post-share__option--copy"
              onClick={handleCopyLink}
            >
              <FontAwesomeIcon icon={faLink} />
              Copy Link
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogPostShare; 